exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-card[data-v-877a8b04]{background-image:var(--DataCardBg);background-size:100% 100%;background-repeat:no-repeat;background-position:center 0}", ""]);

// exports
